import * as React from 'react';
import { FormattedMessage } from 'react-intl';

import {
  DrawerContext,
  FilterChip,
  IconRegularClose,
} from '@notino/react-styleguide';
import { WishlistSortBy } from '@notino/shared/definitions/types';

import { useWishlistStore } from '@containers/WishList/store';

import { DrawerTitle } from '../components/DrawerTitle';

import messages from './messages';
import { SortByOptionsList } from './SortByOptionsList';
import { Divider, FilterChipsWrapper, FiltersSectionWrapper } from './styled';

export const FiltersSection = () => {
  const { openDrawer, closeDrawer } = DrawerContext.useDrawerContext();
  const { setSelectedSortBy } = useWishlistStore((x) => x.actions);
  const selectedSortBy = useWishlistStore((x) => x.selectedSortBy);
  const sortByOptions = useWishlistStore((x) => x.sortByOptions);
  const totalProductCount = useWishlistStore(
    (state) => state.totalProductCount
  );

  const openSortingDrawer = () => {
    openDrawer(<SortByOptionsList />, {
      title: (
        <DrawerTitle
          name={<FormattedMessage {...messages.sorting} />}
          onRefreshButtonClick={() => {
            setSelectedSortBy(WishlistSortBy.Default);
            closeDrawer();
          }}
        />
      ),
      showCloseIcon: false,
      showFade: true,
      isTitleBorderHidden: true,
      allowResize: false,
    });
  };

  if (totalProductCount < 5) {
    return <Divider hideOnDesktop={true} />;
  }

  const sortActive = selectedSortBy !== WishlistSortBy.Default;

  return (
    <FiltersSectionWrapper>
      <FilterChipsWrapper>
        <FilterChip
          title={
            sortActive ? (
              sortByOptions.find((x) => x.sortBy === selectedSortBy)?.name
            ) : (
              <FormattedMessage {...messages.sorting} />
            )
          }
          isActive={sortActive}
          onClick={openSortingDrawer}
          secondaryIcon={<IconRegularClose width="16px" height="16px" />}
          onSecondaryIconClick={
            sortActive && (() => setSelectedSortBy(WishlistSortBy.Default))
          }
        />
      </FilterChipsWrapper>
      <Divider />
    </FiltersSectionWrapper>
  );
};
